import { SecurityLevel } from "./types/User";
import LoginPage from "./pages/login/LoginPage";
import OverviewPage from "./pages/overview/OverviewPage";
import PromptsPage from "./pages/prompts/PromptsPage";
import PromptEditorPage from "./pages/prompts/PromptEditorPage";
import CompaniesPage from "./pages/companies/CompaniesPage";
import PlatformAdminsPage from "./pages/platform-admins/PlatformAdminsPage";

interface MaijaRoute {
  path: string;
  nameKey: string;
  securityLevel: SecurityLevel;
  component: React.ComponentType;
  showInNav?: boolean;
}

export const LOGIN_ROUTE: MaijaRoute = {
  path: "/login",
  nameKey: "nav.title",
  securityLevel: SecurityLevel.None,
  component: LoginPage,
};

export const OVERVIEW_ROUTE: MaijaRoute = {
  path: "/",
  nameKey: "nav.overview",
  securityLevel: SecurityLevel.PlatformAdmin,
  component: OverviewPage,
  showInNav: true,
};

export const PROMPTS_ROUTE: MaijaRoute = {
  path: "/prompts",
  nameKey: "nav.prompts",
  securityLevel: SecurityLevel.PlatformAdmin,
  component: PromptsPage,
  showInNav: true,
};

export const PROMPT_EDITOR_ROUTE: MaijaRoute = {
  path: "/prompts/:name",
  nameKey: "prompts.editor_title",
  securityLevel: SecurityLevel.PlatformAdmin,
  component: PromptEditorPage,
};

export const COMPANIES_ROUTE: MaijaRoute = {
  path: "/companies",
  nameKey: "nav.companies",
  securityLevel: SecurityLevel.PlatformAdmin,
  component: CompaniesPage,
  showInNav: true,
};

export const ADMINS_ROUTE: MaijaRoute = {
  path: "/admins",
  nameKey: "nav.admins",
  securityLevel: SecurityLevel.PlatformAdmin,
  component: PlatformAdminsPage,
  showInNav: true,
};

export const maijaRoutes: MaijaRoute[] = [
  OVERVIEW_ROUTE,
  PROMPTS_ROUTE,
  PROMPT_EDITOR_ROUTE,
  COMPANIES_ROUTE,
  ADMINS_ROUTE,
];

export function getMaijaRoutes(): MaijaRoute[] {
  return maijaRoutes;
}

export function getNavRoutes(): MaijaRoute[] {
  return maijaRoutes.filter((route) => route.showInNav);
}

export default MaijaRoute;
